<template>
  <svg width="25px" height="19px" viewBox="0 0 25 19" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <path d="M50.1630859,207.95752 C48.4394531,216.226725 42.3470052,219.933431 31.8857422,219.077637 C34.452474,215.835775 35.5996094,212.129069 35.3271484,207.95752 L50.1630859,207.95752 Z" id="path-1"/>
      <filter x="-38.3%" y="-44.5%" width="176.6%" height="224.5%" filterUnits="objectBoundingBox" id="filter-2">
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
        <feColorMatrix values="0 0 0 0 0.0156862745   0 0 0 0 0.168627451   0 0 0 0 0.317647059  0 0 0 0.412614729 0" type="matrix" in="shadowBlurOuter1"/>
      </filter>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-29.000000, -206.000000)">
        <g>
          <use fill="black" fill-opacity="0.4" filter="url(#filter-2)" xlink:href="#path-1"/>
          <use fill="currentColor" fill-rule="evenodd" xlink:href="#path-1"/>
        </g>
      </g>
    </g>
  </svg>
</template>
